import { TFunction } from 'i18next';
import { AddToastParams } from './useToast';

export function getMessagesControl<
  T extends Record<string, (t: TFunction, ...params: string[]) => AddToastParams>,
>(messages: T): T {
  return messages;
}
